import { Inject, Pipe, PipeTransform } from '@angular/core';
import { LxlibI18NService, LXLIB_I18N_TOKEN } from './i18n';

@Pipe({ name: 'i18n' })
export class I18nPipe implements PipeTransform {
  constructor(@Inject(LXLIB_I18N_TOKEN) private i18n: LxlibI18NService) {}

  transform(key: string, interpolateParams?: {}, isSafe?: boolean): string {
    return this.i18n.fanyi(key, interpolateParams, isSafe);
  }
}
